import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
  Trust,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import { Advantages, Collage } from "./Sections";

export default function WhyUs() {
  useEffect(() => {
    axios.get(API_URL + "get_news").then((res) => {
      setNews(res.data);
    });
  }, []);
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="anigrad">
          <div
            style={{
              // height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
              paddingTop:"130px"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
                marginTop: state.auth.isMobile ? "50px" : "0px",
                textAlign: state.auth.isMobile ? "left" : "center",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile ? "40px" : "75px",
                  textAlign: state.auth.isMobile ? "left" : "center",
                  color: "white",
                  zIndex: 999,
                  fontWeight: 600,
                }}
              >
                Why choose{" "}
                <span
                  style={{
                    // color: "yellow",
                    // textDecoration: "underline",
                    // textDecorationStyle: "wavy",
                    // textUnderlineOffset: "20px",
                  }}
                >
                  CGT Solutions
                </span>
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "25px 0px 25px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "45px",
                  color: "white",
                  zIndex: 999,
                }}
              >
                Transforming businesses through technology.
              </div>
            </div>
          </div>
          <div
            style={{
              textAlign: "left",
              padding: state.auth.isMobile ? "40px" : " 10px 190px",
            }}
          >
            <div
              onClick={() => {
                navigate("/about");
              }}
              style={{
                fontSize: state.auth.isMobile ? "30px" : "40px",
                color: "white",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Let`s get to know each other
            </div>
            <div
              onClick={() => {
                navigate("/about");
              }}
              style={{
                marginTop: "50px",
                fontSize: state.auth.isMobile ? "20px" : "20px",
                color: "white",
                cursor: "pointer",
                marginBottom: "-100px",
              }}
            >
              CGT Solutions is your go-to partner for IT solutions, uniquely combining innovation, 
              expertise, and a customer-centric approach. Our tailored strategies ensure seamless 
              integration of technology with your business needs, optimizing efficiency and productivity. 
              With a team of skilled professionals, we deliver scalable, cost-effective solutions designed
              to adapt to your growth. Whether it's workforce management or cutting-edge IT support, 
              CGT Solutions empowers your organization to thrive in today’s competitive landscape.
            </div>
          </div>
          <div
            style={{
              textAlign: "left",
              padding: state.auth.isMobile ? "40px" : " 140px 190px",
            }}
          >
            <div
              style={{
                fontSize: "30px",
                color: "white",
                cursor: "pointer",
              }}
            >Today, <span>CGT Solutions</span>{" "} 
            stands as a market leader and is recognized globally for our excellence and commitment to driving business success.
            </div>
          </div>
        </div>
        <SpacerV height={"50px"} />
        <div style={{ display: state.auth.isMobile ? "none" : "block" }}>
          <Trust />
        </div>
        <SpacerV height={"25px"} />
        <Advantages
          invert
          title="Why Choose CGT Solutions?"
          title1={"Innovative and Tailored Solutions"}
          subtitle1={
            "At CGT Solutions, we deliver cutting-edge, customized IT solutions designed to meet your unique business needs. Our innovative approach ensures that you stay ahead of the competition while addressing your specific challenges."
          }
          title2={"Expert Team and Proven Expertise"}
          subtitle2={
            "Our team of seasoned professionals brings years of experience and deep industry knowledge to every project. With a proven track record of success, we provide reliable and high-quality solutions that drive results."
          }
          title3={"Seamless Integration and Implementation"}
          subtitle3={
            "We ensure smooth and hassle-free integration of our solutions into your existing systems. Our meticulous implementation process minimizes disruptions and maximizes efficiency, so you can start seeing results quickly."
          }
          title4={"Commitment to Your Success"}
          subtitle4={
            "At CGT Solutions, your success is our priority. We work closely with you to understand your goals and deliver solutions that align with your vision. Our ongoing support and dedication ensure long-term growth and success for your business."
          }
        />
        <div style={{ display: state.auth.isMobile ? "none" : "block" }}>
          <Collage />
        </div>
        <div
          style={{
            marginTop: "150px",
            marginBottom: "-50px",
            fontSize: state.auth.isMobile ? "30px" : "40px",
            color: themeStyle.primaryColor,
            zIndex: 999,
            backgroundColor: "white",
            fontWeight: 600,
          }}
        >
          Get To Know Us Better
        </div>
        <Stats />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
